export const getConfig = () => {
  const env = import.meta.env;
  const enableOutboundClidControls: boolean = (() => {
    if (env && env.VITE_ENABLE_OUTBOUND_CLID_CONTROLS) {
      if (env.VITE_ENABLE_OUTBOUND_CLID_CONTROLS === 'true') {
        return true;
      } else if (env.VITE_ENABLE_OUTBOUND_CLID_CONTROLS === 'false') {
        return false;
      } else {
        return false;
      }
    } else {
      return false;
    }
  })();

  const enableRecordingControls: boolean = (() => {
    if (env && env.VITE_ENABLE_CALL_RECORDING_CONTROLS) {
      if (env.VITE_ENABLE_CALL_RECORDING_CONTROLS === 'true') {
        return true;
      } else if (env.VITE_ENABLE_CALL_RECORDING_CONTROLS === 'false') {
        return false;
      } else {
        return false;
      }
    } else {
      return false;
    }
  })();

  const config = {
    OAUTH_RESPONSE_TYPE: env.VITE_OAUTH_RESPONSE_TYPE,
    OAUTH_SCOPES: env.VITE_OAUTH_SCOPES,
    REGION: env.VITE_REGION,
    USER_POOL_ID: env.VITE_USER_POOL_ID,
    USER_POOL_CLIENT_ID: env.VITE_USER_POOL_CLIENT_ID,
    DOMAIN_URL: env.VITE_DOMAIN_URL,
    COGNITO_SAML_IDP_NAME: env.VITE_COGNITO_SAML_IDP_NAME,
    CCP_URL: env.VITE_CCP_URL,
    CCP_SSO_URL: env.VITE_CCP_SSO_URL,
    SERVER_API_BASE_URL: env.VITE_SERVER_API_BASE_URL,
    CONNECT_INSTANCE_DOMAIN: env.VITE_CONNECT_INSTANCE_DOMAIN,
    ENVIRONMENT: env.VITE_ENVIRONMENT,
    RECORD_ON_DEMAND_SG_ID: env.VITE_RECORD_ON_DEMAND_SG_ID,
    USER_SG_ATTRIBUTE_NAME: env.VITE_USER_SG_ATTRIBUTE_NAME,
    ENABLE_OUTBOUND_CLID_CONTROLS: enableOutboundClidControls,
    ENABLE_CALL_RECORDING_CONTROLS: enableRecordingControls,
    REALTIME_API_WS_HOST: env.VITE_REALTIME_API_WS_HOST,
    REALTIME_API_WS_STAGE: env.VITE_REALTIME_API_WS_STAGE

  };
  return config;
};
